import * as Password from '../../constants/Password';

const initialState = {
  Loading: false,
  Loaded: true,
  err: '',
  result: false,
};

export default function password(state: any = initialState, action: any) {
  switch (action.type) {
    case Password.PROCESS_CHANGE_PASSWORD:
      return Object.assign({}, state, {
        Loading: true,
        Loaded: false,
      });
    case Password.DONE_CHANGE_PASSWORD:
      return Object.assign({}, state, {
        err: action.error,
        Loading: false,
        Loaded: true,
        result: action.result,
      });
    case Password.PROCESS_FORGOT_PASSWORD:
      return Object.assign({}, state, {
        Loading: true,
        Loaded: false,
      });
    case Password.DONE_FORGOT_PASSWORD:
      return Object.assign({}, state, {
        err: action.error,
        Loading: false,
        Loaded: true,
        result: action.result,
      });
    case Password.PROCESS_CONFIRM_PASSWORD:
      return Object.assign({}, state, {
        Loading: true,
        Loaded: false,
      });
    case Password.DONE_CONFIRM_PASSWORD:
      return Object.assign({}, state, {
        err: action.error,
        Loading: false,
        Loaded: true,
        result: action.result,
      });
    case Password.RESET_STATUS:
      return Object.assign({}, state, {
        err: '',
        Loading: false,
        Loaded: true,
        result: false,
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/Password.tsx